import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent(props) {
    const { color, size } = props;
  return (
    <Svg width={10} height={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <Path
      stroke={color}
      strokeWidth={2}
      d="M11 2L2 9.5l9 7.5"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
  )
}

export default SvgComponent
